class LoginUtils {
  static replaceDomain (link) {
    if (typeof link !== 'string') {
      return link
    }

    return link
      .replace('www.airbaltic.com', 'open.airbaltic.com')
      .replace('btrixnginxtest01.airbaltic.com', 'opent.airbaltic.com')
      .replace('btrixcmsaptest01.airbaltic.com', 'opent.airbaltic.com')
  }
}

export default LoginUtils
